import { CategoryPageProps } from "./CategoryPageProps";
import { CategoryPage } from "./CategoryPage";
import styled from "@emotion/styled";
import { BreadcrumbItem, Breadcrumbs } from "@kaltura/ds-react-components";
import { kafSystemWidth, systemWidth } from "@kaltura/mediaspace-shared-styled";
import { useContext } from "react";
import { ConfigContext } from "@kaltura/mediaspace-shared-data-kms-config";

export interface GalleryPageProps extends CategoryPageProps {
    breadcrumbs?: BreadcrumbItem[];
}

export const GalleryPage = ({ breadcrumbs = [], ...props }: GalleryPageProps) => {
    const config = useContext(ConfigContext);
    const isKaf = config.application?.isKAF;

    return (
        <StyledContainer>
            {!!breadcrumbs?.length && (
                <StyledBreadcrumbs
                    items={[
                        ...breadcrumbs,
                        // Add an empty item in the end to render extra separator icon
                        { label: <></> },
                    ]}
                    isKaf={isKaf}
                />
            )}

            <CategoryPage {...props} />
        </StyledContainer>
    );
};

export default GalleryPage;

const StyledContainer = styled("div")(({ theme }) => ({
    marginTop: theme.spacing(4),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
}));

export const StyledBreadcrumbs = styled(
    Breadcrumbs,
    { shouldForwardProp: (propName) => propName !== "isKaf" }
)<{ isKaf?: boolean }>(({ theme, isKaf }) => ({
    "&": isKaf ? kafSystemWidth({ theme }) : systemWidth({ theme }),
}));
